<template>
<v-dialog 
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="none"
    >
  <v-card color="primary" dark flat tile class="mx-auto" :max-width="800">
    <v-btn text v-if="windows.length>1 && !mandatory" @click="dialog=false" style="position:absolute;right:20px;top:20px;z-index:10">overslaan</v-btn>
    <v-window v-model="onboarding" class="fill-height mx-auto pb-15" style="max-width:600px">
      <v-window-item v-for="(window,step) in windows" :key="`card-${step}`" >
        <v-card color="transparent" class="fill-height pa-5 px-10" flat>
          <v-row align="center" justify="center" class="pt-15">
            <v-img  v-if="window.img"
                  :src="require('@/assets/login.png')"
                  contain
                  height="30vh"
                />
                </v-row>
            <v-row align="center" justify="center">
              
                <v-card-title class="text-h4 text-center font-weight-thin" justify="center" style="word-break: keep-all" v-text="window.title"></v-card-title>
              <v-card-text align="center" class="text-h6 font-weight-light" v-text="window.description">
                
              </v-card-text>
              <slot name="content" v-bind="{ step, window }"></slot>
          </v-row>
        </v-card>
        <v-card-actions class="justify-space-between pr-5" color="primary" v-if="windows.length>1 || $slots.buttons">
          <slot name="leftbuttons"></slot>
          <v-btn text @click="close" v-if="window.cancel"> {{window.cancel}} </v-btn>
          <v-btn text @click="next" v-if="window.bypass"> {{window.bypass}} </v-btn>
          <slot name="buttons" v-bind="{ step, window, next, prev, close}">
            <v-spacer></v-spacer>
            <v-btn text @click="next" v-if="window.next"> {{window.next}} </v-btn>
            <v-btn text @click="close" v-if="window.done"> {{window.done}} </v-btn>
          </slot>
        </v-card-actions>
      </v-window-item>
    </v-window>
    <v-footer fixed class="justify-center mb-15" color="primary">
      <!--v-btn text @click="prev">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn-->
      <v-item-group v-model="onboarding" class="text-center" mandatory v-if="navigation && windows.length>1">
        <v-item
          v-for="(window,n) in windows"
          :key="`btn-${n}`"
          v-slot="{ active, toggle }"
        >
          <v-btn :input-value="active" icon @click="toggle">
            <v-icon>mdi-record</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
       <v-btn text @click="dialog=false" v-else-if="windows.length>0 && windows[0].done"> {{windows[0].done}} </v-btn>
      <!--v-btn text @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn-->
    </v-footer>
    
    
  </v-card>
</v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: function () {
        return []
      },
    },
    show: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    mandatory: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    navigation: {
      type: Boolean,
      default: function () {
        return false
      },
    },
   },
  data: () => ({
    onboarding: 0
  }),
  computed: {
    ...mapGetters([
        'config'
      ]),
    windows(){
      return this.$config.landing[this.type] || []
    },
    dialog: {
      get(){
        if (this.show) return true
        if (!this.$config.landing[this.type]) return false
        return !(this.config.onboarding || []).includes(this.type)
      },
      set(value){
        let arr = (this.config.onboarding || []).filter(a=>a!=value)
        if (value==false) arr.push(this.type)
        this.setConfig({onboarding: arr})
      }
    },
  },
  methods: {
      ...mapActions([
        'setConfig'
      ]),
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },
    close(){
      this.dialog=false
    }
  },
};
</script>
